module.exports = __webpack_public_path__ + "media/images/logo-old-b14dab9c32bb1b329febd342707ef15f.png";